import React from 'react';
import { Wrap, Image, Text, Overlay } from './Loader.styled';
import Label from '../Label';

const Loader = ({ label = 'loadingLabel' }) => (
  <>
    <Overlay></Overlay>
    <Wrap>
      <Image src="/images/dealer-locator/loading.gif" alt="" />
      <Text>
        <Label name={label} fallback=" "></Label>
      </Text>
    </Wrap>
  </>
);

export default Loader;
